var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHuaweiAppGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -96.6111,
    y1: 34.4444,
    x2: -96.6111,
    y2: 33.1111,
    gradientTransform: "matrix(36 0 0 -36 3502 1240)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FB6361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED3E45"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.468,0C3.607,0,0,3.606,0,13.465v21.069C0,44.394,3.607,48,13.468,48h21.058C44.386,48,48,44.394,48,34.535 V13.465C48,3.606,44.393,0,34.532,0H13.468z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.937,27.839h1.927l-0.967-2.248L20.937,27.839z M20.463,28.972l-0.572,1.308h-1.302L21.358,24h1.125 l2.757,6.28h-1.336l-0.564-1.308H20.463z M41.409,30.276h1.258V24h-1.258V30.276z M36.401,27.58h2.319v-1.144h-2.319v-1.286h3.366 v-1.145h-4.624v6.275h4.745v-1.145h-3.488V27.58z M31.403,28.321L29.976,24h-1.041l-1.426,4.321l-1.388-4.318h-1.357l2.191,6.28 h1.055l1.429-4.125l1.429,4.125h1.064l2.185-6.28h-1.322L31.403,28.321z M16.669,27.597c0,1.022-0.507,1.567-1.429,1.567 c-0.926,0-1.436-0.562-1.436-1.611v-3.549h-1.275v3.593c0,1.767,0.982,2.781,2.694,2.781c1.729,0,2.72-1.033,2.72-2.833V24h-1.274 V27.597z M9.487,24h1.274v6.284H9.487v-2.552H6.608v2.552H5.333V24h1.275v2.535h2.879V24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,16c-4.412,0-8-3.589-8-8h1.13c0,3.788,3.082,6.87,6.87,6.87s6.87-3.082,6.87-6.87H32 C32,12.411,28.411,16,24,16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHuaweiAppGallery);
export default __webpack_public_path__ + "static/media/icon_huawei_app_gallery.0c3dd60107ceadaffe8c5fce275bce16.svg";
export { ForwardRef as ReactComponent };